import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CheckTickIcon, CrossIcon } from "@cinch-nx/design-system-icons";
import styles from "./seo-table.module.css";
function renderBody(body) {
    if (body.includes("*check-tick-icon*")) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(CheckTickIcon, {
                    size: 24
                }),
                /*#__PURE__*/ _jsx("div", {
                    children: body.replace("*check-tick-icon*", "")
                })
            ]
        });
    } else if (body.includes("*cross-icon*")) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(CrossIcon, {
                    size: 24
                }),
                /*#__PURE__*/ _jsx("div", {
                    children: body.replace("*cross-icon*", "")
                })
            ]
        });
    } else {
        return body;
    }
}
export const SEOTable = ({ heading , table  })=>/*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            heading && /*#__PURE__*/ _jsx("h2", {
                className: styles.heading,
                children: heading
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.scroll,
                children: /*#__PURE__*/ _jsxs("table", {
                    className: styles.table,
                    "aria-label": heading,
                    children: [
                        /*#__PURE__*/ _jsx("thead", {
                            children: /*#__PURE__*/ _jsx("tr", {
                                children: table.thead.map((heading)=>/*#__PURE__*/ _jsx("th", {
                                        "aria-label": heading.value,
                                        children: heading.value
                                    }, heading._uid))
                            })
                        }),
                        /*#__PURE__*/ _jsx("tbody", {
                            children: table.tbody.filter((row)=>!!row.body[0].value).map((row)=>/*#__PURE__*/ _jsx("tr", {
                                    children: row.body.map((cell)=>/*#__PURE__*/ _jsx("td", {
                                            "aria-label": cell.value.toString(),
                                            children: renderBody(cell.value.toString())
                                        }, cell._uid))
                                }, row._uid))
                        })
                    ]
                })
            })
        ]
    });
